export const QUESTIONNAIRE_COLUMNS = [
  {
    key: 'pipe_strap_location',
    answerKeys: ['pipe_strap_location', 'pipe_strap_used'],
  },
  {
    key: 'sprinkler_system_type',
    answerKeys: ['sprinkler_system_type'],
  },
  {
    key: 'zip_code',
    answerKeys: ['zip_code', '_ours_zip'],
  },
];

export const QUESTIONNAIRE_COLUMN_KEYS = QUESTIONNAIRE_COLUMNS.map(column => column.key);

export const hasQuestionnaireAnswer = value => {
  return value !== undefined && value !== null && String(value).trim() !== '';
};

export const availableQuestionnaireColumnKeys = sensors => {
  const items = Array.isArray(sensors) ? sensors : Object.values(sensors || {});

  return QUESTIONNAIRE_COLUMNS
    .filter(column => items.some(sensor => {
      return column.answerKeys.some(key => hasQuestionnaireAnswer(sensor?.[key]));
    }))
    .map(column => column.key);
};

const normalizedAnswer = value => String(value ?? '').trim().toLowerCase();

const pipeStrapIsUsed = value => {
  if (!hasQuestionnaireAnswer(value)) return null;

  return !['0', 'false', 'no', 'off'].includes(normalizedAnswer(value));
};

export const formatPipeStrapLocation = sensor => {
  const isUsed = pipeStrapIsUsed(sensor?.pipe_strap_used);
  const location = String(sensor?.pipe_strap_location ?? '').trim();
  const normalizedLocation = normalizedAnswer(location);

  if (isUsed === false || normalizedLocation === 'declined') return 'Not Used';
  if (normalizedLocation === 'branch_line' || normalizedLocation === 'branch line') return 'Branch Line';
  if (normalizedLocation === 'riser_pipe' || normalizedLocation === 'riser pipe') return 'Riser Pipe';
  if (location) return location;
  if (isUsed === true) return 'Used';

  return '';
};

export const formatSprinklerSystemType = sensor => {
  const answer = String(sensor?.sprinkler_system_type ?? '').trim();

  switch (normalizedAnswer(answer)) {
    case 'wet':
    case 'wet system':
      return 'Wet System';
    case 'dry':
    case 'dry system':
      return 'Dry System';
    case 'wet_and_dry':
    case 'wet and dry':
    case 'wet & dry':
    case 'wet & dry system':
      return 'Wet & Dry System';
    default:
      return answer;
  }
};

// The API stores the zip code already normalised (US 12345 / 12345-6789 or a
// Canadian "A1A 1A1"), so display it as-is.
// The enterprise's own zip for the sensor (GET /map/overlay) comes first.
export const formatZipCode = sensor => {
  return String(sensor?._ours_zip || sensor?.zip_code || '').trim();
};
